<template>

  <div v-if="toDos && toDos.length>0" style="position:relative;">
    <mdb-card v-for="(t,i) in toDos" :key="i" class="mb-2">
      <mdb-card-header class="warning-color text-left text-white">
        <h5>Notice</h5>
      </mdb-card-header>
      <mdb-card-body class="text-left">
        <div>{{ t.text }}</div>
        <router-link class="btn btn-default btn-sm btn-rounded ripple-parent" v-if="t.linkText && t.link" :to="t.link">{{ t.linkText }}</router-link>

        <mdb-btn icon="check-circle"
                 size="sm" rounded
                 @click="announceAck(t)">Dismiss
        </mdb-btn>

      </mdb-card-body>



    </mdb-card>
  </div>

</template>

<script>
import {mdbBtn, mdbCard, mdbCardBody, mdbCardFooter, mdbCardHeader, mdbIcon} from 'mdbvue';
import api from "../../services/groupsPlaceApi";

export default {
  name: 'top-alerts',
  components: {
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardFooter,
    mdbIcon
  },
  data() {
    return {
      showAlerts: false
    }
  },
  computed: {
    toDos: function () {
      return this.$store.state.toDos
    }
  },
  methods: {
    announceAck(a, followLink) {
      api.get("/user/announceAck/" + a.id).then(
        (response) => {
          let loc = this.toDos.indexOf(a)
          this.toDos.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({
                               message: "Error saving acknowledgement" + error.response.status,
                               timeOut: 5000,
                               position: 'top center'
                             })
        }
      );
    },

  }
};
</script>

<style scoped>

.top-alert-body {
  padding: 0px 10px 0px 10px;
}

</style>
